// path: src/Recap.js

import React, { useState } from "react";
import "./App.css";
import DifficultyDialog from "./Components/DifficultyDialog";
import {
    CHALLENGING_START_LEVEL,
    HARD_START_LEVEL,
    scoreAtStartOfLevel,
} from "./utils/progression";

const Recap = ({
    outcome = "loss", // "win" | "loss"
    levelReached = 1,
    correctClicks = 0,
    foilsFound = 0,
    newlyUnlocked = 0,
    totalUnlocked = 0,
    totalCards = 113,
    runMode = "normal",
    runEndReason = "",
    runElapsedText = "0:00",
    onPlayAgain,
    onMainMenu,
}) => {
    const [difficultyOpen, setDifficultyOpen] = useState(false);

    const handlePlayAgainClick = () => {
        setDifficultyOpen(true);
    };

    const handlePickDifficulty = (mode, options = {}) => {
        let startLevel = 1;

        if (mode === "challenging") {
            startLevel = CHALLENGING_START_LEVEL;
        }

        if (mode === "hard") {
            startLevel = HARD_START_LEVEL;
        }

        if (mode === "blitz") {
            startLevel = 1;
        }

        const startScore = scoreAtStartOfLevel(startLevel);

        onPlayAgain({
            startLevel,
            startScore,
            twistedMode: Boolean(options.twistedMode),
            shyCorgisMode: Boolean(options.shyCorgisMode),
            hardcoreMode: mode === "blitz" ? true : Boolean(options.hardcoreMode),
            blitzMode: mode === "blitz",
        });

        setDifficultyOpen(false);
    };

    const subtitle =
        runMode === "blitz" && runEndReason === "blitz-timeout"
            ? `Time ran out at Level ${levelReached}.`
            : outcome === "win"
            ? "Final level cleared."
            : `You reached Level ${levelReached}.`;

    return (
        <div className="recapScreen">
            <div className="recapCard">
                <h1 className="impactFont recapTitle">
                    {outcome === "win" ? "You Won!" : "Run Ended"}
                </h1>

                <div className="recapSubTitle">{subtitle}</div>

                <div className="recapStats">
                    <div className="recapStat">
                        <div className="recapStatLabel">Mode</div>
                        <div className="recapStatValue">
                            {runMode === "blitz" ? "Blitz" : "Normal"}
                        </div>
                    </div>

                    <div className="recapStat">
                        <div className="recapStatLabel">
                            {runMode === "blitz" ? "Final Time" : "Run Time"}
                        </div>
                        <div className="recapStatValue">{runElapsedText}</div>
                    </div>

                    <div className="recapStat">
                        <div className="recapStatLabel">Highest Level Reached</div>
                        <div className="recapStatValue">{levelReached}</div>
                    </div>

                    <div className="recapStat">
                        <div className="recapStatLabel">Correct Clicks</div>
                        <div className="recapStatValue">{correctClicks}</div>
                    </div>

                    <div className="recapStat">
                        <div className="recapStatLabel">Cards Unlocked (This Run)</div>
                        <div className="recapStatValue">+{newlyUnlocked}</div>
                    </div>

                    <div className="recapStat">
                        <div className="recapStatLabel">Foils Found (This Run)</div>
                        <div className="recapStatValue">{foilsFound}</div>
                    </div>

                    <div className="recapStat">
                        <div className="recapStatLabel">Collection</div>
                        <div className="recapStatValue">
                            {totalUnlocked}/{totalCards}
                        </div>
                    </div>
                </div>

                <div className="recapButtons">
                    <button className="homePrimaryButton" onClick={handlePlayAgainClick}>
                        Play Again
                    </button>

                    <button className="homePrimaryButton" onClick={onMainMenu}>
                        Main Menu
                    </button>
                </div>

                <div className="recapHint">
                    {runMode === "blitz"
                        ? ""
                        : outcome === "win"
                        ? "Nice! Your collection progress was saved."
                        : "Try again — your collection progress was saved."}
                </div>
            </div>

            <DifficultyDialog
                open={difficultyOpen}
                onClose={() => setDifficultyOpen(false)}
                onPick={handlePickDifficulty}
            />
        </div>
    );
};

export default Recap;